import React, { useEffect, useState } from "react";
import Modal from "components/modal";
import useToggle from "hooks/useToggle";
import { countries, SITE_URL, stayInCountry } from "utils/constants";
import { navigate } from "gatsby";
import { useGlobalContext } from "context/global";

const CountryDetector = () => {
	const { translation } = useGlobalContext();

	const [country, setCountry] = useState("");
	const [isOpen, toggleModal] = useToggle();

	const fetchCountry = async () => {
		try {
			const response = await fetch("/api/geo");

			if (response.status === 404) 
				return console.error("Geolocation data not found. Please make sure to run 'netlify dev' to retrieve geolocation data.");
			
			const data = await response.json();

			const store = countries.find((country) => country?.code === data.country.code);

			if (!store || store.url === SITE_URL) return;

			setCountry({
				url: store.url,
				...data.country
			});
			toggleModal();

		} catch (error) {
			console.error("Error fetching geo data:", error);
		}
	};

	const handleStay = () => {
		toggleModal();
		localStorage.setItem(stayInCountry, "true");
	};

	const handleContinue = () => {
		if (!country) return;
		navigate(country.url);
	};

	useEffect(() => {
		const shouldStayHere = JSON.parse(localStorage.getItem(stayInCountry) ?? "false");

		if (!shouldStayHere)
			fetchCountry();

	}, []);

	return (
		<Modal isOpen={isOpen} className="w-90 mx-auto md:max-w-md" headerStyle="!pb-1 !pr-4" close={handleStay}>
			<div className="w-full flex justify-center flex-col">
				<p className="text-secondary text-lg mx-auto text-left mb-6 w-10/12">
					{translation?.redirect_popup?.title.replace("{country}", country?.name)}
					<br />
					<br />
					<strong>{translation?.redirect_popup?.questionText.replace("{country}", country?.name)}</strong>
				</p>
				<button className="btn-primary px-2.5 my-2 mx-auto w-4/5" onClick={handleContinue}>
					{translation?.redirect_popup?.acceptRedirect}
				</button>
				<button className="btn-tertiary px-2.5 my-2 mx-auto w-4/5 text-base" onClick={handleStay}>
					{translation?.redirect_popup?.declineRedirect}
				</button>
			</div>
		</Modal>
	);
};

export default CountryDetector;
